import React from 'react';
import PropTypes from 'prop-types';
import { Form, Col, Button, Spinner } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import IconAlert from 'components/common/IconAlert';
import SelectorMoneda from './SelectorMoneda';

/**
 * Componente para el panel lateral con detalles y controles de la orden
 */
const PanelDetalleOrden = ({
    totales,
    formasPago,
    fechaLimitePago,
    confirmandoOrden,
    onCambiarFormaPago,
    onCambiarFechaVenta,
    onCambiarFechaVencimiento,
    onCambiarMoneda,
    onConfirmar
}) => {
    return (
        <div>
            <div className="text-center text-md-center text-xl-center text-xxl-center">
                <SelectorMoneda
                    monedaSeleccionada={totales.vMoneda}
                    onCambiarMoneda={onCambiarMoneda}
                />

                <div className="border-dashed border-bottom d-block d-md-none d-xl-block d-xxl-none my-4" />

                <div className="fs-2 fw-semi-bold">Total a pagar:</div>
                <div className="fs-2 fw-semi-bold">
                    <span className="text-primary">
                        {totales.dTotal === 0
                            ? "----"
                            : `${totales.dTotal.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD'
                            })} ${totales.vMoneda}`}
                    </span>
                </div>

                {totales.dTipoCambio > 1 && (
                    <div className="fs--2">
                        <span className="text-muted fw-bold">
                            {"T.C. " + totales.dTipoCambio + "  |  " + 
                                new Date(totales.dFechaVenta).toLocaleDateString('es-mx', {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric'
                                })}
                        </span>
                    </div>
                )}

                <Form.Select
                    className="mb-3 mt-5"
                    onChange={(e) => onCambiarFormaPago(e.target.value)}
                    value={totales.idCatFormaPago}
                >
                    <option value="">Selecciona forma de pago</option>
                    {formasPago.map((fp, index) => (
                        <option key={index} value={fp.idCatFormaPago}>
                            {fp.vDescripcionFormaPago}
                        </option>
                    ))}
                </Form.Select>

                <Col className="col-12">
                    <DatePicker
                        selected={new Date(totales.dFechaVenta)}
                        onChange={onCambiarFechaVenta}
                        maxDate={new Date()}
                        dateFormat="dd MMMM yyyy"
                        className="form-control col-12"
                        editable="false"
                    />
                </Col>

                {fechaLimitePago && (
                    <>
                        <IconAlert className="mb-0" variant="warning">
                            <p className="mb-0">Fecha limite pago</p>
                        </IconAlert>
                        <Form.Control
                            onChange={(e) => onCambiarFechaVencimiento(e.target.value)}
                            className="mb-3"
                            type="date"
                            size="md"
                        />
                    </>
                )}

                {confirmandoOrden ? (
                    <Button variant="secondary" disabled className="mt-3 px-5 fs--1">
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            className="me-2"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button>
                ) : (
                    <Button
                        variant="success"
                        className="mt-3 px-5"
                        type="submit"
                        onClick={onConfirmar}
                    >
                        Confirmar &oacute;rden
                    </Button>
                )}

                <p className="fs--1 mt-3 mb-0">
                    Al hacer clic <strong>confirmas la &oacute;rden </strong> de compra de acuerdo a
                    los <a href="">T&eacute;rminos &amp; Condiciones de Akasia Software Development, Sa de Cv</a>
                </p>
            </div>
        </div>
    );
};

PanelDetalleOrden.propTypes = {
    totales: PropTypes.shape({
        vMoneda: PropTypes.string.isRequired,
        dTotal: PropTypes.number.isRequired,
        dTipoCambio: PropTypes.number.isRequired,
        dFechaVenta: PropTypes.string.isRequired,
        idCatFormaPago: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired
    }).isRequired,
    formasPago: PropTypes.arrayOf(PropTypes.shape({
        idCatFormaPago: PropTypes.number.isRequired,
        vDescripcionFormaPago: PropTypes.string.isRequired
    })).isRequired,
    fechaLimitePago: PropTypes.bool.isRequired,
    confirmandoOrden: PropTypes.bool.isRequired,
    onCambiarFormaPago: PropTypes.func.isRequired,
    onCambiarFechaVenta: PropTypes.func.isRequired,
    onCambiarFechaVencimiento: PropTypes.func.isRequired,
    onCambiarMoneda: PropTypes.func.isRequired,
    onConfirmar: PropTypes.func.isRequired
};

export default PanelDetalleOrden;
